import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { editUser, getUserDetail } from "reduxStore/action/usersActions";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import strings from "translate/language";
import {
  getAge,
  nameValid,
  handleListResponse,
  seo,
  handleDetailResponse,
  isEmpty,
  ValidateExtensionImge,
  validateAadhaar,
  pancardValidation,
  emailAddressValid,
  mobileNumberValid,
} from "utils/utils";
import { resolveProfileImageSrc } from "utils/profileImage";
import moment from "moment";
import Select from "react-select";
import { getCityList } from "reduxStore/action/masterActions";
import Breadcrumb from "component/common/breadcrumb";
// import { getRoleList } from "reduxStore/action/roleActions";
import Input from "../../component/Input";
import Button from "../../component/Button";
import { LoginType, emailEndPoint } from "utils/constants";

const UserEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { user_id = "" } = params || {};
  const [formVaild, setFormVaild] = useState(null);
  const [form, setForm] = useState({});
  const [image, setImage] = useState({ preview: "", raw: "" });
  // const [userList, setUserList] = useState([]);
  // const [rolesList, setRolesList] = useState([]);
  // const [isHeadTL, setIsHeadTL] = useState(false);

  const dispatch = useDispatch();
  const RegisterAddUserSelector = useSelector((state) => state.userData);
  const GetCityListSelector =
    useSelector((state) => state.cityMasterData?.response?.data) || [];

  // const getRoleListSelector = useSelector((state) => state.roleData);

  // const userListSelector = useSelector((state) => state.userData);

  const handleChange = (e) => {
    if (e.target.files.length) {
      const validFile = ValidateExtensionImge(e.target);
      let preview = "";
      let image = "";
      if (validFile === true) {
        preview = URL.createObjectURL(e.target.files[0]);
        image = e.target.files[0];
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: null,
        });
      } else {
        preview = "";
        image = "";
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: validFile,
        });
      }
      const nextFormState = {
        preview: preview,
        raw: image,
      };
      setImage(nextFormState);
    }
  };

  useEffect(() => {
    seo({
      title: "Edit User",
      metaDescription: "Edit user details",
      canonicalLink: window.location.href,
    });
  }, []);
  // useEffect(() => {
  //   const { response } = getRoleListSelector;
  //   if (response) {
  //     if (response?.status === 200) {
  //       let filterData = handleListResponse(response.data).filter(
  //         (i) => i._id !== CPAgent && i._id !== ChannelPartner
  //       );
  //       setRolesList(filterData);
  //     } else {
  //       setRolesList([]);
  //     }
  //   }
  // }, [getRoleListSelector]);

  useEffect(() => {
    dispatch(getUserDetail({ user_id: user_id }));
    dispatch(getCityList());
    // dispatch(getRoleList());
  }, [dispatch, user_id]);

  useEffect(() => {
    if (RegisterAddUserSelector.create === true) {
      if (RegisterAddUserSelector?.userData?.status === 200) {
        setForm({});
        navigate("/user");
      }
    }
    if (RegisterAddUserSelector.detail === true) {
      if (RegisterAddUserSelector?.userData?.status === 200) {
        const { userData } = RegisterAddUserSelector;
        const data = handleDetailResponse(userData.data);
        setForm({
          role_id: data?.role_id,
          firstname: data?.firstname,
          lastname: data?.lastname,
          email: data?.email.split("@")[0],
          mobile: data?.mobile,
          gender: data?.gender,
          dateofbirth: data?.dateofbirth,
          adhar_no: data?.adhar_no,
          pancard_no: data?.pancard_no,
          address: data?.address,
          city: data?.city
            ? data?.city
            : GetCityListSelector.find((i) => i.city_id === data?.city_id)
              ?.city_name,
          cityObj: GetCityListSelector.find((i) => i.city_id === data?.city_id),
          city_id: data?.city_id,
          area: data?.area,
          justo_employee_code: data?.justo_employee_code,
          longitude: data?.longitude,
          latitude: data?.latitude,
          sourcing_head: data?.sourcing_head,
          isHeadTL: data?.sourcing_head,
          login_type: data?.login_type,
        });
        // if (data?.sourcing_head && !isEmpty(data?.parent_name)) {
        //   let obj = {
        //     [SourcingManager]: SourcingTL,
        //     [ClosingManager]: ClosingTL,
        //   };
        //   dispatch(
        //     getUserFilterDetail({
        //       limit: 100,
        //       offset: 0,
        //       role_id: obj[data?.role_id],
        //     })
        //   );
        //   setIsHeadTL(true);
        // }
        setImage({
          preview: resolveProfileImageSrc({
            baseUrl: data?.base_url,
            profilePicture: data?.profile_picture,
          }),
        });
      }
    }
  }, [dispatch, navigate, RegisterAddUserSelector, GetCityListSelector]);

  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      area: e,
      // address: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };
  const onSelect = (latLng, area) => {
    const nextFormState = {
      ...form,
      area: area,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  // useEffect(() => {
  //   if (userListSelector?.userData) {
  //     const { userData } = userListSelector;
  //     if (userData?.status === 200) {
  //       setUserList(handleListResponse(userData?.data));
  //     } else {
  //       setUserList([]);
  //     }
  //   }
  // }, [userListSelector]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]:
        e.target.name === "adhar_no"
          ? e.target.value
            .replace(/\D/g, "")
            .split(/(?:([\d]{4}))/g)
            .filter((s) => s.length > 0)
            .join(" ")
          : e.target.value,
    };
    setForm(nextFormState);
    // if (
    //   e.target.name === "role_id" &&
    //   (e.target.value === SourcingManager || e.target.value === ClosingManager)
    // ) {
    //   setIsHeadTL(true);

    //   let obj = {
    //     [SourcingManager]: SourcingTL,
    //     [ClosingManager]: ClosingTL,
    //   };
    //   dispatch(
    //     getUserFilterDetail({
    //       limit: 100,
    //       offset: 0,
    //       role_id: obj[e.target.value],
    //     }) // sourcing_head id
    //   );
    // } else {
    //   if (
    //     e.target.name === "role_id" &&
    //     (e.target.value !== SourcingManager ||
    //       e.target.value !== ClosingManager)
    //   ) {
    //     setIsHeadTL(false);
    //   }
    // }
  };
  const handleEdit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      if (image.raw) {
        formData.append("profile_picture", image.raw);
      }
      formData.append("user_id", user_id);
      formData.append("role_id", form.role_id);
      formData.append("firstname", form.firstname);
      formData.append("lastname", form.lastname);
      formData.append("email", form.email + emailEndPoint);
      formData.append("gender", form.gender);
      formData.append("mobile", form?.mobile);
      formData.append("dateofbirth", form.dateofbirth ? form.dateofbirth : "");
      formData.append("pancard_no", form?.pancard_no ? form?.pancard_no : "");
      formData.append("adhar_no", form.adhar_no ? form.adhar_no : "");
      formData.append("address", form.address ? form.address : "");
      formData.append("city", form.city ? form.city : "");
      formData.append("city_id", form.city_id ? form.city_id : 0);
      formData.append("area", form.area ? form.area : "");
      formData.append("justo_employee_code", form.justo_employee_code);
      formData.append("longitude", form.longitude ? form.longitude : "");
      formData.append("latitude", form.latitude ? form.latitude : "");
      formData.append("login_type", form.login_type);
      // if (isHeadTL) {
      //   formData.append("sourcing_head", form.isHeadTL);
      //   formData.append("parent_id", form.isHeadTL);
      // }

      dispatch(editUser(formData));
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
    // if (!form.role_id) {
    //   formError = true;
    //   err["role_id"] = strings.role_idErr;
    // }
    if (!form.firstname) {
      formError = true;
      err["firstname"] = strings.firstnameErr;
    } else if (!nameValid(form.firstname)) {
      formError = true;
      err["firstname"] = strings.nameValidErr;
    }
    if (!form.lastname) {
      formError = true;
      err["lastname"] = strings.lastnameErr;
    } else if (!nameValid(form.lastname)) {
      formError = true;
      err["lastname"] = strings.nameValidErr;
    }
    if (!form.email) {
      formError = true;
      err["email"] = strings.emailErr;
    } else if (!emailAddressValid(form.email + emailEndPoint)) {
      formError = true;
      err["email"] = strings.useremailErr;
    }
    if (!form.mobile) {
      formError = true;
      err["mobile"] = strings.mobileErr;
    } else if (!mobileNumberValid(form.mobile)) {
      formError = true;
      err["mobile"] = strings.mobileValidErr;
    }
    if (Number(form.gender) === 1 || Number(form.gender) === 2) {
    } else {
      formError = true;
      err["gender"] = strings.genderErr;
    }
    // if (!form.dateofbirth) {
    //   formError = true;
    //   err["dateofbirth"] = strings.dateofbirthErr;
    // } else
    if (getAge(form.dateofbirth) < 18) {
      formError = true;
      err["dateofbirth"] = strings.dateofbirthErr2;
    }
    if (form.adhar_no && !validateAadhaar(form.adhar_no)) {
      formError = true;
      err["adhar_no"] = strings.validAadhar_Err;
    }
    if (form.pancard_no && !pancardValidation(form.pancard_no)) {
      formError = true;
      err["pancard_no"] = strings.validPancard_Err;
    }
    if (!form.justo_employee_code) {
      formError = true;
      err["justo_employee_code"] = strings.justoEmpCodeErr;
    }
    // if (!form.address) {
    //   formError = true;
    //   err["address"] = strings.addressErr;
    // }
    // if (!form.city_id) {
    //   formError = true;
    //   err["city_id"] = strings.cityErr;
    // } else if (form.city_id === strings.city) {
    //   formError = true;
    //   err["city_id"] = strings.cityErr;
    // }
    // if (!form.area) {
    //   formError = true;
    //   err["area"] = strings.areaErr;
    // } else if (!form.longitude) {
    //   formError = true;
    //   err["area"] = strings.validAddressErr;
    // } else if (form.longitude === "undefined") {
    //   formError = true;
    //   err["area"] = strings.validAddressErr;
    // }
    // if (isHeadTL) {
    //   if (!form.isHeadTL) {
    //     formError = true;
    //     err["is_head_tl"] = strings.parentErr;
    //   } else if (form.isHeadTL === strings.selectParent) {
    //     formError = true;
    //     err["is_head_tl"] = strings.parentErr;
    //   }
    // }
    if (!form.login_type) {
      formError = true;
      err["login_type"] = strings.login_type;
    }
    if (!isEmpty(err)) {
      formError = true;
    }
    setFormVaild(err);
    return formError;
  };
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.edituser}
        url={"/user"}
        parentListing={strings.userListing}
        titleactive={strings.edituser}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.edituser}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-2">
                      <label
                        htmlFor="upload-button"
                        style={{
                          position: "relative",
                        }}
                      >
                        <img
                          src={resolveProfileImageSrc({ preview: image.preview })}
                          alt=""
                          width="150"
                          height="150"
                          style={{ borderRadius: "50%" }}
                          title={strings.editImage}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "84%",
                            left: "12px",
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            width: 130,
                            display: "flex",
                            justifyContent: "center",
                            borderBottomLeftRadius: 40,
                            borderBottomRightRadius: 40,
                          }}
                        >
                          {" "}
                          <img
                            src="/assets/fonts/feather/edit.svg"
                            title="Edit Profile"
                            alt=""
                          />
                        </div>
                      </label>
                      <div className="profile-edit"></div>
                      <input
                        type="file"
                        id="upload-button"
                        style={{ display: "none" }}
                        onChange={handleChange}
                      />
                      <br />
                    </div>
                  </div>
                  {formVaild?.validMedia && (
                    <span style={{ color: "red" }}>
                      {formVaild?.validMedia}
                    </span>
                  )}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          name="justo_employee_code"
                          placeholder={strings.justoEmpCode}
                          value={form.justo_employee_code}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.justoEmpCode}
                          requiredLabel={true}
                          error={formVaild?.justo_employee_code}
                          maxLength={30}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-8 ">
                      <div className="mb-3">
                        <Input
                          type="text"
                          name="firstname"
                          placeholder={strings.firstName}
                          value={form.firstname}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.firstName}
                          requiredLabel={true}
                          error={formVaild?.firstname}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          name="lastname"
                          placeholder={strings.lastName}
                          value={form.lastname}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.lastName}
                          requiredLabel={true}
                          error={formVaild?.lastname}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.emailAddress}
                          <span className="required-field"></span>
                        </label>
                        <div class="input-group">
                          <input
                            className="form-control"
                            autocomplete="off"
                            id="exampleFormControlLastName"
                            type="text"
                            name="email"
                            value={form.email}
                            placeholder={strings.EmailUsername}
                            onChange={handleInputField}
                            autoComplete="off"
                          />
                          <div class="input-group-append">
                            <span class="input-group-text">@justo.co.in</span>
                          </div>
                        </div>
                        {formVaild?.email && (
                          <span style={{ color: "red" }}>
                            {formVaild?.email}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="email"
                          placeholder={strings.emailaddress}
                          readOnly
                          name="email"
                          value={form.email}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.emailAddress}
                        />
                      </div>
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          maxLength={10}
                          placeholder={strings.mobileNo}
                          name="mobile"
                          value={form.mobile}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.mobileNo}
                          error={formVaild?.mobile}
                          requiredLabel={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row pb-3">
                    <div className="row pl-4">
                      <label htmlFor="exampleInputMobileNo " className="pr-4">
                        {strings.gender}
                        <span className="required-field"></span>
                      </label>
                      <div className="form-check pr-4">
                        <input
                          className="form-check-input "
                          type="radio"
                          name="gender"
                          value={1}
                          checked={Number(form.gender) === 1 ? true : false}
                          onChange={handleInputField}
                        />

                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          {strings.male}
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          value={2}
                          checked={Number(form.gender) === 2 ? true : false}
                          onChange={handleInputField}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          {strings.female}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="date"
                          placeholder={strings.dob}
                          name="dateofbirth"
                          value={form.dateofbirth}
                          onChange={handleInputField}
                          label={strings.dob}
                          error={formVaild?.dateofbirth}
                          minDateRange="1920-01-01"
                          maxDateRange={moment()
                            .subtract(18, "years")
                            .format("yyyy-MM-DD")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.aadharNo}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlLastName"
                          type="text"
                          maxLength={14}
                          name="adhar_no"
                          value={form.adhar_no}
                          placeholder={strings.aadharNoExample}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.adhar_no && (
                          <span style={{ color: "red" }}>
                            {formVaild?.adhar_no}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.pancardNo}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="text"
                          name="pancard_no"
                          maxLength={10}
                          value={form.pancard_no}
                          placeholder={strings.panNumberExample}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.pancard_no && (
                          <span style={{ color: "red" }}>
                            {formVaild?.pancard_no}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.city}
                        </label>
                        <Select
                          isSearchable
                          isClearable={true}
                          options={handleListResponse(GetCityListSelector)}
                          getOptionLabel={(option) => `${option.city_name}`}
                          getOptionValue={(option) => option.city_id}
                          name="cityObj"
                          value={form.cityObj}
                          onChange={(val) => {
                            const nextFormState = {
                              ...form,
                              cityObj: val,
                            };
                            if (val) {
                              nextFormState.city = val?.city_name;
                              nextFormState.city_id = val?.city_id;
                            } else {
                              nextFormState.city = "";
                              nextFormState.city_id = "";
                            }
                            setForm(nextFormState);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          placeholder={strings.address}
                          name="address"
                          value={form.address}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.address}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <AutocompletePlace
                          placeholder={strings.area}
                          value={form.area}
                          onChange={handleInputArea}
                          onSelect={onSelect}
                          label={strings.area}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div>
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.loginAccess}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control digits"
                          name="login_type"
                          value={form.login_type}
                          onChange={handleInputField}
                        >
                          <option value="">{strings.selectLoginType}</option>
                          {LoginType.map((item, index) => (
                            <option key={index} value={item.value}>
                              {`${item.lable}`}
                            </option>
                          ))}
                        </select>
                        {formVaild?.login_type && (
                          <span style={{ color: "red" }}>
                            {formVaild?.login_type}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 ">
                    <div className="card-footer float-right">
                      <Button
                        className="btn btn-color"
                        onClick={() => handleEdit()}
                        label={strings.update}
                      ></Button>
                    </div>
                  </div>
                </div>
                {!isEmpty(formVaild) && (
                  <span
                    style={{
                      color: "red",
                      float: "right",
                    }}
                  >
                    {strings.allFieldRequired}
                  </span>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserEdit;
